/**
 * Mass Item Upload Reducer
 * @author agal0301
 * */
import { RESET_MASS_ITEM_UPLOAD_DATA, UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA } from '../actions/massItemUploadActions';
import initialState from './initialState';

export default function massItemUploadReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.massItemUpload;
  }

  if (type === RESET_MASS_ITEM_UPLOAD_DATA) {
    return {
      validRecords: [],
      invalidRecords: [],
      importedFileName: null
    };
  }

  if (type === UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA) {
    return { ...state, ...data };
  }

  return state;
}
